import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.scss'
import './styles/mobile.scss'
import i18n from './i18n'
import 'flag-icons/css/flag-icons.min.css'
import ConsultButton from '@/components/ConsultButton.vue'
import ConsultButtonDesktop from '@/components/ConsultButtonDesktop.vue'
import FooterNav from '@/components/FooterNav.vue'
import SmartImage from '@/components/SmartImage.vue'
import { ResponsivePlugin } from '@/utils/responsiveManager.js'
import { ImagePreloaderPlugin, imagePreloader } from '@/utils/imagePreloader.js'
import { RoutePreloaderPlugin } from '@/utils/routePreloader.js'
import { PerformanceMonitorPlugin } from '@/utils/performanceMonitor.js'
import { ServiceWorkerPlugin } from '@/utils/serviceWorkerManager.js'
import { Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';
import VueLazyload from 'vue-lazyload';
// 引入字体加载器
import { fontLoader } from '@/utils/fontLoader.js'

Vue.use(ElementUI)
Vue.use(ResponsivePlugin)
Vue.use(ImagePreloaderPlugin)
Vue.use(RoutePreloaderPlugin)
Vue.use(PerformanceMonitorPlugin)
Vue.use(ServiceWorkerPlugin)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/images/logo.png'),
  attempt: 1
});

Vue.config.productionTip = false

Vue.component('ConsultButton', ConsultButton)
Vue.component('ConsultButtonDesktop', ConsultButtonDesktop)
Vue.component('FooterNav', FooterNav)
Vue.component('SmartImage', SmartImage)

// 异步初始化应用
async function initApp() {
  try {
    // 并行初始化字体加载器和图片预加载
    await Promise.allSettled([
      fontLoader.init(),
      imagePreloader.detectWebpSupport()
    ]);
    
    console.log('字体加载器初始化完成');
    console.log('WebP支持检测完成:', imagePreloader.supportsWebp);

    // 创建Vue实例
    const app = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');

    // 应用启动后开始预加载关键图片
    setTimeout(() => {
      imagePreloader.preloadCriticalImages().catch(error => {
        console.warn('关键图片预加载失败:', error);
      });
    }, 100);

    return app;
  } catch (error) {
    console.error('应用初始化失败:', error);
    // 即使初始化失败，也要启动应用
    return new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
}

// 启动应用
initApp(); 